import _ from 'lodash';
import { INSPECTION_ITEM_TYPE } from '@/_legacy/constants';
import SubItems from '@/_legacy/views/Analytics/Checklist/Items/SubItems';

function shouldDisplay(item) {
  return !item.params || (item.params && !item.params.automatic);
}

function hasQuestionElements(item) {
  return _.filter(
    item.items,
    subItem => subItem.type === INSPECTION_ITEM_TYPE.QUESTION && shouldDisplay(subItem),
  ).length > 0;
}

export default {
  name: 'ItemWithSubItems',
  functional: true,
  render(createElement, { props, parent }) {
    let title = '';
    if (props.item.title) {
      title = props.breadcrumb
        ? [props.breadcrumb, props.item.title].join(' > ')
        : props.item.title;
    } else if (
      props.item.type === INSPECTION_ITEM_TYPE.PAGE && props.item.params && props.item.params.header === true
    ) {
      title = parent.$t('Header page');
    } else if (props.item.type === INSPECTION_ITEM_TYPE.PAGE && props.hasMultiplePages) {
      title = parent.$t('(page title not set)');
    } else if (props.item.type === INSPECTION_ITEM_TYPE.SECTION) {
      title = parent.$t('(section title not set)');
    }

    const titleElement = title && hasQuestionElements(props.item)
      ? createElement('h2', { class: 'mt-8 mb-4 text-2xl font-semibold' }, title)
      : null;

    return [
      titleElement,
      createElement(SubItems, {
        props: {
          items: props.item.items,
          breadcrumb: title || props.breadcrumb,
          questions: props.questions,
          responseSets: props.responseSets,
          hasMultiplePages: props.hasMultiplePages,
          questionsToFetch: props.questionsToFetch
        },
      }),
    ];
  },
};
